module.exports = __webpack_public_path__ + "img/frame (232).a412c11c.jpg";